'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import { useState } from 'react';
import Image from 'next/image';
import Link from '@eliadmin/core/src/components/link';

import type { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';
import type { Reference } from '@eliadmin/core/src/api/references/references-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../ui/heading';
import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { RiFacebookCircleFill, RiGlobalLine, RiInstagramLine } from 'react-icons/ri';

export function References({
  references,
  title,
  generalLayout,
}: {
  references: Reference[];
  title: string;
  generalLayout: GeneralLayout['data'];
}) {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <section
        id="referencie"
        className={cn('custom-section', 'py-8 sm:py-10 md:py-12 lg:py-16', 'section-gap')}
      >
        <Heading title={title} center />
        <div
          className={cn(
            'custom-container',
            'grid grid-cols-2 gap-2 sm:grid-cols-3 md:gap-4 lg:grid-cols-4 xl:gap-6',
          )}
        >
          {references.map(reference => {
            const allImages = [reference?.image, ...(reference?.images ?? [])].filter(Boolean);

            return (
              <Image
                key={reference?.id}
                src={allImages[0]?.url || ''}
                alt={resolveImageAlt(allImages?.[0], allImages?.[0]?.name || '')}
                width={500}
                height={500}
                onClick={handleOpenGallery(allImages, 0)}
                className="aspect-square w-full cursor-pointer overflow-hidden rounded-[6px] object-cover object-center transition-all hover:opacity-90"
                sizes="( max-width: 640px ) 50vw, ( max-width: 768px ) 33vw, 50vw"
              />
            );
          })}
        </div>
        <div className="flex flex-col items-center justify-center gap-4 lg:gap-6">
          <h3
            data-ea-visual-tag="h5"
            className="text-special-green text-center text-xl font-bold sm:text-2xl lg:text-3xl"
          >
            Pozrite si náš Facebook, Instagram alebo stránku!
          </h3>
          <div className="flex flex-wrap items-center justify-center gap-4">
            {!!generalLayout?.social_media?.facebook && (
              <Link
                target="_blank"
                href={generalLayout?.social_media?.facebook}
                className=" green-btn flex items-center justify-start gap-2.5 rounded-md p-3 pr-5 text-white transition
          "
              >
                <RiFacebookCircleFill size={24} /> Mojapraca.eu
              </Link>
            )}

            {!!generalLayout?.social_media?.instagram && (
              <Link
                target="_blank"
                href={generalLayout?.social_media?.instagram}
                className=" green-btn flex items-center justify-start gap-2.5 rounded-md p-3 pr-5 text-white transition"
              >
                <RiInstagramLine size={24} /> _mojapraca.eu
              </Link>
            )}
            <Link
              target="_blank"
              href={'https://kaufmann-bau.eu/'}
              className=" green-btn flex items-center justify-start gap-2.5 rounded-md p-3 pr-5 text-white transition"
            >
              <RiGlobalLine size={24} /> KAUFMANN BAU s.r.o
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
